import React from 'react'
import LxnxAuthorPrimaryInfo from './LxnxAuthorPrimaryInfo'
import LxnxAuthorSecondaryInfo from './LxnxAuthorSecondaryInfo'

type LxnxAuthorColumnProps = {
  name?: string
  sourceName: string
}

const LxnxAuthorColumn = ({ name, sourceName }: LxnxAuthorColumnProps) =>
  name ? (
    <>
      <LxnxAuthorPrimaryInfo message={name} />
      <LxnxAuthorSecondaryInfo message={sourceName} />
    </>
  ) : (
    <LxnxAuthorPrimaryInfo message={sourceName} />
  )

export default LxnxAuthorColumn
